module.exports = __webpack_public_path__ + "img/8.58b96dd8.png";